import { Range } from 'rc-slider';
import Dinero from 'dinero.js';

const wrapperStyle = { width: '100%' };

const CompoundSlider = (props) => {
  const { onChange, unit, defaultValue, min, max, label, step, pushable } = props;
  const formattedMinCurrencyValue = Dinero({ amount: parseInt(defaultValue[0], 10), precision: 0 }).toFormat('$0,0');
  const formattedMaxCurrencyValue = Dinero({ amount: parseInt(defaultValue[1], 10), precision: 0 }).toFormat('$0,0');
  const lowerLengthRange = parseInt(defaultValue[0], 10);
  const displayPlus = defaultValue[1] === 70 && unit === "'" ? '+' : '';
  const displayCurrencyPlus = formattedMaxCurrencyValue === '$1,000' ? '+' : '';
  const hideLowerPriceRange = formattedMinCurrencyValue === '$0' ? '$1 - ' : `${formattedMinCurrencyValue} - `;
  const hideLowerLengthRange = lowerLengthRange === 69 ? '' : `${lowerLengthRange}' - `;
  return (
    <div className="" style={wrapperStyle}>
      <div className="u-flex u-flexRow u-flexRow u-flexJustifyBetween u-flexAlignCenter u-mb2">
        <span className="compound-slider-label">{label}</span>
        <span className="compound-slider-values">
          {unit === '$' ? hideLowerPriceRange : hideLowerLengthRange}
          {unit === '$' ? formattedMaxCurrencyValue : parseInt(defaultValue[1], 10)}
          {unit === "'" ? "'" : ''}
          {displayPlus}
          {displayCurrencyPlus}
        </span>
      </div>

      <Range
        min={min}
        max={max}
        allowCross={false}
        value={defaultValue}
        onChange={onChange}
        step={step}
        pushable={pushable}
      />
    </div>
  );
};

export default CompoundSlider;
